
import { Component, Prop, Vue } from 'vue-property-decorator'
import { PaginationData, validatePaginationData } from '~/utility/pagination'
import { reportError } from '~/utility/reportError'
import type { SearchFilters } from '../schemas'

@Component
export default class SearchResultsPaginationControls extends Vue {
  @Prop()
    searchFilters: SearchFilters

  @Prop({
    required: true,
    validator: (v) => {
      try {
        validatePaginationData(v)
        return true
      } catch (err) {
        reportError(err as Error)
        return false
      }
    },
  })
    paginationData: PaginationData

  get currentPage() {
    return this.paginationData.currentPage
  }

  get totalPages() {
    return this.paginationData.totalPages
  }

  get isFirst() {
    return this.currentPage === 1
  }

  get isLast() {
    return this.currentPage === this.totalPages
  }

  get isFirstOfMany() {
    return this.isFirst && this.totalPages > 1
  }

  getSearchUrlProps(page: number) {
    let category: string | undefined = 'search'
    let facet: string | undefined
    const modifyFilters: SearchFilters = { page }
    const isCategorySlugUrl = ['glamping-search', 'category-search'].includes(
      this.$route.meta?.type,
    )

    if (isCategorySlugUrl) {
      category = this.$route.meta!.category
      modifyFilters.categoryIds = undefined
      if (this.shouldReplaceFacet) {
        facet = this.searchFilters.facets![0]
        modifyFilters.facets = undefined
      }
    }
    return {
      moveSingleFacetIntoUrl: false,
      category,
      excludeType: 'paginationControl',
      modifyFilters,
      facet,
    }
  }

  private get shouldReplaceFacet() {
    return (
      this.searchFilters.facets?.length === 1 &&
      this.$route.path.includes(`/-/${this.searchFilters.facets[0]}/`)
    )
  }
}
